import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { HomePage } from "./../home/home";
import { ViewHeader2Page } from "./../view-header2/view-header2";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { QuizResultPage } from "./../quiz-result/quiz-result";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-quiz-test",
  templateUrl: "quiz-test.html",
})
export class QuizTestPage {
  interval: any;
  interval2: any;
  stepTest: any = 0;
  answerID: any = "";
  answerTrue: any = "";
  loadProgress: any = 1;
  nowTime: any = 0;
  quizRound: any;
  data: any;

  quiz_id: any = 1;
  quiz_row: any = 0;
  quiz_true: any = 0;
  quiz_false: any = 0;
  quiz_total: any = 0;
  question_desc = "";
  answer1 = "";
  answer2 = "";
  answer3 = "";
  answer4 = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private http: Http,
    private services: ServiceProvider,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.interval2 = setInterval(() => {
      this.nowTime += 1000;
      this.loadProgress = Math.floor((this.nowTime / 30000) * 100);
    }, 1000);

    this.interval = setInterval(() => {
      if (this.quiz_id == this.quiz_total) {
        let result = {
          quiz_true: this.quiz_true,
          quiz_false: this.quiz_false,
          quiz_total: this.quiz_total,
        };
        this.storage.set("quizResult", result);
        clearInterval(this.interval);
        clearInterval(this.interval2);
        this.navCtrl.setRoot(QuizResultPage);
      } else {
        this.quiz_id += 1;
        this.quiz_row += 1;
        let result = {
          quiz_id: this.quiz_id,
          quiz_row: this.quiz_row,
          quiz_true: this.quiz_true,
          quiz_false: this.quiz_false,
          quiz_total: this.quiz_total,
        };
        this.storage.set("quizResult", result);
        clearInterval(this.interval);
        clearInterval(this.interval2);
        this.navCtrl.setRoot(QuizTestPage);
      }
    }, 30000);
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("quizRound").then((round) => {
      this.quizRound = round;
    });

    this.storage.get("token").then((token) => {
      this.storage.get("language").then((language) => {
        this.storage.get("quizResult").then((quiz) => {
          try {
            this.storage.get("quiz").then((quizData) => {
              this.data = quizData;
            });

            this.quiz_total = quiz.quiz_total;
            this.quiz_true = quiz.quiz_true;
            this.quiz_false = quiz.quiz_false;
            this.quiz_row = quiz.quiz_row;
            this.quiz_id = quiz.quiz_id;
            this.question_desc = this.data[this.quiz_row].question_title;
            this.answer1 = "A. " + this.data[this.quiz_row].choice_1;
            this.answer2 = "B. " + this.data[this.quiz_row].choice_2;
            this.answer3 = "C. " + this.data[this.quiz_row].choice_3;
            this.answer4 = "D. " + this.data[this.quiz_row].choice_4;
            loader.dismiss();
          } catch (error) {
            var headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Authorization", "Bearer " + token);
            const requestOptions = new RequestOptions({ headers: headers });

            var link =
              this.services.URLQuiz +
              "?set_no=" +
              this.quizRound +
              "&lang=" +
              language;

            this.http
              .get(link, requestOptions)
              .map((res) => res.json())
              .subscribe(
                (data) => {
                  this.data = data;
                  this.storage.set("quiz", this.data);

                  this.quiz_total = this.data.length;
                  this.question_desc = this.data[this.quiz_row].question_title;
                  this.answer1 = "A. " + this.data[this.quiz_row].choice_1;
                  this.answer2 = "B. " + this.data[this.quiz_row].choice_2;
                  this.answer3 = "C. " + this.data[this.quiz_row].choice_3;
                  this.answer4 = "D. " + this.data[this.quiz_row].choice_4;
                  loader.dismiss();
                },
                (error) => {
                  var response = JSON.parse(error._body);
                  loader.dismiss();
                  this.translateService
                    .get(response.message)
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              );
          }
        });
      });
    });
  }

  answer(ansID) {
    this.answerID = ansID;
  }

  confirm() {
    if (this.answerID == "") {
      this.translateService.get("Please select answer.").subscribe((value) => {
        this.services.presentToast(value);
      });
    } else {
      clearInterval(this.interval);
      clearInterval(this.interval2);
      this.stepTest = 1;
      this.answerTrue = this.data[this.quiz_row].choice_true;
      if (this.answerTrue == this.answerID) {
        this.quiz_true += 1;
        let result = {
          quiz_id: this.quiz_id,
          quiz_row: this.quiz_row,
          quiz_true: this.quiz_true,
          quiz_false: this.quiz_false,
          quiz_total: this.quiz_total,
        };
        this.storage.set("quizResult", result);
      } else {
        this.quiz_false += 1;
        let result = {
          quiz_id: this.quiz_id,
          quiz_row: this.quiz_row,
          quiz_true: this.quiz_true,
          quiz_false: this.quiz_false,
          quiz_total: this.quiz_total,
        };
        this.storage.set("quizResult", result);
      }
    }
  }

  next() {
    if (this.quiz_id == this.quiz_total) {
      let result = {
        quiz_true: this.quiz_true,
        quiz_false: this.quiz_false,
        quiz_total: this.quiz_total,
      };
      this.storage.set("quizResult", result);
      clearInterval(this.interval);
      clearInterval(this.interval2);
      this.navCtrl.setRoot(QuizResultPage);
    } else {
      this.quiz_id += 1;
      this.quiz_row += 1;
      let result = {
        quiz_id: this.quiz_id,
        quiz_row: this.quiz_row,
        quiz_true: this.quiz_true,
        quiz_false: this.quiz_false,
        quiz_total: this.quiz_total,
      };
      this.storage.set("quizResult", result);
      clearInterval(this.interval);
      clearInterval(this.interval2);
      this.navCtrl.setRoot(QuizTestPage);
    }
  }

  doRefresh(refresher) {
    var link = this.services.URLCheckStep;

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              if (data.step >= 3) {
                if (
                  this.storage.remove("quizRound") &&
                  this.storage.remove("quizResult") &&
                  this.storage.remove("quiz")
                ) {
                  clearInterval(this.interval);
                  clearInterval(this.interval2);
                  this.storage.set("stepGame", "home");

                  if (info.role == 1) {
                    this.navCtrl.setRoot(HomePage);
                  } else if (info.role == 2) {
                    this.navCtrl.setRoot(MerchantHomePage);
                  } else if (info.role == 3) {
                    this.navCtrl.setRoot(ShopperHomePage);
                  }
                }
              }
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });

    refresher.complete();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/quiz-test/quiz-test.ts